// extracted by mini-css-extract-plugin
module.exports = {"content":"_3TXtI","header":"_1h99C","body":"rU1iW","img":"_1mS4V","text":"u5cWF","title":"I9c8I","subtitle":"KT6s1","marketplaces":"JhYQu","agency":"_2WwUh"};